<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <input :name="field.name + 'street'" class="street" v-model="val.street" :placeholder="field.placeholders.street[currentLanguage]" @change="dataChanged" type="text" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <input :name="field.name + 'number'" class="number" v-model="val.number" :placeholder="field.placeholders.number[currentLanguage]" @change="dataChanged" type="number" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <input :name="field.name + 'zipcode'" class="zipcode" v-model="val.zipcode" :placeholder="field.placeholders.zipcode[currentLanguage]" @change="dataChanged" type="text" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <input :name="field.name + 'residence'" class="residence" v-model="val.residence" :placeholder="field.placeholders.residence[currentLanguage]" @change="dataChanged" type="text" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <multiselect :name="field.name + 'country'" v-if="countrylist.length > 0" track-by="countrycode" label="country" @input="countrySelected" :value="val.country" :options="countrylist" :placeholder="field.placeholders.country[currentLanguage]"></multiselect>
    <p class="small" v-if="field.description[currentLanguage]">{{ field.description[currentLanguage] }}</p>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'countries'],
  components: {
    Multiselect
  },
  data () {
    return {
      val: this.value,
      countrylist: []
    }
  },
  methods: {
    countrySelected (e) {
      this.val.country = e
      this.$emit('input', this.val)
      this.$emit('change', '')
    },
    dataChanged () {
      this.$emit('input', this.val)
      this.$emit('change', '')
    }
  },
  created () {
    Object.keys(this.countries).forEach(country => {
      this.countrylist.push({
        countrycode: country,
        country: this.countries[country][this.currentLanguage]
      })
    })
    if (this.val.country.length > 3) {
      this.val.country = this.countrylist.filter(country => {
        return country.country === this.val.country
      })[0]
    }
  }
}
</script>

<style>
  .zipcode, .number {
    display: inline-block;
    width: 100px;
    margin-right: 10px;
  }
  .number {
    margin-right: 0px;
  }
  .residence, .street {
    display: inline-block;
    width: calc( 100% - 114px );
  }
  .street {
    margin-right: 10px;
  }


.multiselect {
  position: relative;
}
.multiselect__current {
  line-height: 16px;
  min-height: 40px;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  margin: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  cursor: pointer;
}

.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #E8E8E8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch;
}
.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
  top: 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: none;
  border-bottom: 1px solid #E8E8E8;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
}
.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
}
.multiselect__option--highlight {
  background: #1e90ff;
  outline: none;
  color: white;
}
.multiselect__option--selected {
  background: #F3F3F3;
  color: #35495E;
  font-weight: bold;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #FF6A6A;
  color: #fff;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  background: #ededed;
  color: #a6a6a6;
  cursor: text;
  pointer-events: none;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede !important;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
.multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/address.vue